<template>
  <v-layout>
    <div class="pros-footer">
      <div class="pros-footer-logo">
        <img src="~@/assets/panthers-logo-sm.png" srcset="~@/assets/panthers-logo-sm.png, ~@/assets/panthers-logo.png 1.5x"/>
      </div>
      <div class="pros-footer-colophon">
        FloridaPanthers.com is the official Web site of the Florida Panthers. Florida Panthers and floridapanthers.com are trademarks of the Florida Panthers Hockey Club, Ltd. NHL, the NHL Shield, the word mark and image of the Stanley Cup and NHL Conference logos are registered trademarks and NHL Draft name and logo are trademarks of the National Hockey League. All NHL logos and marks and NHL team logos and marks as well as all other proprietary materials depicted herein are the property of the NHL and the respective NHL teams and may not be reproduced without the prior written consent of NHL Enterprises, L.P. Copyright &copy; 1999-{{ new Date().getFullYear() }} Florida Panthers Hockey Club, Ltd and the National Hockey League. All Rights Reserved.
      </div>
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'DefaultFooter'
}
</script>
<style>
  .pros-footer {background: #fff;font-size: .75em; padding: 20px;color: #666;text-align: center;}
  .pros-footer .pros-footer-logo {width: 70px;display: inline-block;margin-right: 10px;vertical-align: top;}
  .pros-footer .pros-footer-logo img {max-width: 100%;}
  .pros-footer .pros-footer-colophon {display: inline-block;max-width: 80%;text-align: left;}
  @media only screen and (max-width:640px) {
  .pros-footer .pros-footer-logo {margin-right: 0;width: 40px;}
  .pros-footer .pros-footer-colophon {max-width: 100%;}
  }

</style>